<template>
    <div class="homepage">
        <div class="buttons">
          <div class="item">
            <div @click="cancel();taskFormVisible = true" class="image homeowrk"><img src="~../assets/homework.svg" alt=""></div>
            <p>新作业</p>
          </div>
          <div class="item">
            <router-link to="/homework/course" class="image course"><img src="~../assets/course.svg" alt=""></router-link>
            <p>班级管理</p>
          </div>
          <div class="item">
            <router-link to="/homework/homework" class="image student"><img src="~../assets/student.svg" alt=""></router-link>
            <p>检查作业</p>
          </div>
        </div>
        <div style="padding:40px;">
          <h3 class="page-title">学生作业完成情况</h3>
          <el-table v-loading="loading" empty-text="No Data" :data="dataList" stripe style="width: 100%">
            <el-table-column prop="student_name" label="学生"></el-table-column>
            <el-table-column prop="course_name" label="班级"></el-table-column>
            <el-table-column prop="lesson_name" label="授课内容"></el-table-column>
            <el-table-column prop="status" label="状态" align="center">
                <template slot-scope="scope">
                    <el-tag :type="tagsColor[scope.row.status]" size="mini">{{tagsTxt[scope.row.status]}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="score" label="成绩" align="center">
                <template slot-scope="scope">
                    <star :stars="getScore(scope.row.results)" :maxStar="3" readonly :star-size="18"></star>
                </template>
            </el-table-column>
            <el-table-column prop="quizzes_count" label="练习题" align="center">
              <template slot-scope="scope">
                  {{scope.row.correct_quizzes_count || 0}}/{{scope.row.quizzes_count || 0}}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="params.page"
              :page-sizes="[20, 50, 100]"
              :page-size="params.per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>

        <el-dialog title="创建新作业" :visible.sync="taskFormVisible">
            <el-form :model="taskForm" ref="taskForm" :rules="rules" label-width="120px">
                <el-form-item prop="course_id" label="班级">
                    <el-select
                      v-model="course_id"
                      filterable
                      remote
                      reserve-keyword
                      loading-text="加载中..."
                      no-match-text="无匹配数据"
                      no-data-text="无数据"
                      placeholder="选择一个班级"
                      :remote-method="searchCourse"
                      :loading="course_loading">
                      <el-option
                        v-for="item in courseList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="lesson_id"  label="授课内容">
                  <el-select
                    v-model="taskForm.lesson_id"
                    filterable
                    remote
                    reserve-keyword
                    loading-text="加载中..."
                    no-match-text="无匹配数据"
                    no-data-text="无数据"
                    placeholder="选择一个授课内容"
                    :remote-method="searchLesson2"
                    :loading="lesson_loading">
                    <el-option
                      v-for="item in lessonList2"
                      :key="item.id"
                      :label="item.subject"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="name" label="新建作业">
                  <el-input v-model="taskForm.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="submitForm">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Star from '../components/Star'
import { DateFormat } from '../common/util'
export default {
  components: { Star },
  data () {
    return {
      dataList: [],
      loading: false,
      params: {
        created_at_gteq: DateFormat(new Date().getTime() + 1 * 86400000),
        page: 1,
        per_page: 20,
        order_by: [],
        fields: []
      },
      total: 0,
      tagsColor: {
        'unread': 'warning',
        'accepted': 'primary',
        'done': 'success'
      },
      tagsTxt: {
        'unread': '未开始',
        'accepted': '进行中',
        'done': '完成'
      },
      course_loading: false,
      lesson_loading: false,
      taskFormVisible: false,
      course_id: '',
      taskForm: {
        id: '',
        lesson_id: '',
        name: ''
      },
      rules: {
        lesson_id: [{ required: true, message: '授课标题不可为空' }],
        name: [{ required: true, message: '作业标题不可为空' }]
      },
      courseList: [],
      lessonList2: []
    }
  },
  created () {
    this.getDataList()
    this.searchCourse()
    // this.searchLesson2()
  },
  watch: {
    course_id (value) {
      if (value) {
        this.searchLesson2()
      }
    }
  },
  methods: {
    submitForm () {
      this.$refs['taskForm'].validate(valid => {
        if (valid) {
          if (!this.taskForm.id) {
            this.$api.tasks
              .create(this.taskForm)
              .then(data => {
                this.$success('作业创建成功')
                this.$store.commit('tmp_task', data)
                this.$router.push('/homework/task/form/' + data.id)
                this.cancel()
                this.getDataList()
              })
              .catch(err => {
                this.$success('Task Create Error')
              })
          } else {
            this.$api.tasks
              .save(this.taskForm.id, this.taskForm)
              .then(data => {
                this.$success('作业保存成功')
                this.cancel()
                this.getDataList()
              })
              .catch(err => {
                this.$success('作业保存失败')
              })
          }
        }
      })
    },
    searchCourse (name) {
      this.course_loading = true
      this.$api.courses
        .list({ fields: ['id', 'name'], page: 1, per_page: 100, name })
        .then(data => {
          this.courseList = data.data
          this.course_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.course_loading = false
        })
    },
    searchLesson2 (subject) {
      this.lesson_loading = true
      this.$api.courses
        .lessons({
          id: this.course_id || '',
          fields: ['id', 'subject'],
          page: 1,
          per_page: 100,
          subject
        })
        .then(data => {
          this.lessonList2 = data
          this.lesson_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.lesson_loading = false
        })
    },
    cancel () {
      this.taskFormVisible = false
      this.taskForm.id = ''
      this.taskForm.lesson_id = ''
      this.taskForm.name = ''
    },
    getScore (results) {
      if (results.length > 0) {
        let sum = results.reduce((sum, n) => {
          return { score: sum.score + n.score }
        }).score

        let ava = sum / results.length
        if (ava < 33.3) {
          return 1
        } else if (ava < 66.7) {
          return 2
        } else {
          return 3
        }
      }
      return 0
    },
    getDataList () {
      this.loading = true
      this.$api.homeworks
        .list(this.params)
        .then(data => {
          this.total = data.total
          this.dataList = data.data
          this.loading = false
        })
        .catch(err => {
          this.$error(err)
          this.loading = false
        })
    },
    handleCurrentChange (page) {
      this.params.page = page
      this.getDataList()
    },
    handleSizeChange (size) {
      this.params.per_page = size
      this.getDataList()
    }
  }
}
</script>
<style lang="scss">
.homepage {
  padding-top: 50px;
  .buttons {
    max-width: 1000px;
    display: flex;
    justify-content: space-around;
    .item {
      text-align: center;
      width: 240px;
      height: 240px;
      .image {
        display: inline-block;
        cursor: pointer;
        width: 120px;
        height: 120px;
        line-height: 120px;
        border-radius: 50%;
        background-color: #fc3;
        &.course {
          background-color: #6cf;
        }
        &.student {
          background-color: #fe6501;
        }
        img {
          display: inline-block;
          vertical-align: middle;
          width: 50%;
          height: 50%;
        }
      }
      p {
        margin-top: 20px;
        text-align: center;
      }
    }
  }
}
</style>
